import React, { useState } from "react";
import { Card, CardHeader, CardBody, Collapse } from "reactstrap";
import { NotAvailabe } from "components/Utils";
import styles from "./SitebarCollapsable.module.css";

const SitebarCollapsable = ({
  header,
  children,
  empty = <NotAvailabe />,
  toggled = false,
}) => {
  const [isOpen, setIsOpen] = useState(toggled);
  const handleToggleClick = () => setIsOpen(!isOpen);
  return (
    <Card className={styles.card}>
      <CardHeader
        className={`dropdown-toggle ${styles.cardHeader}${
          isOpen ? ` ${styles.toggled}` : ""
        }`}
        onClick={handleToggleClick}
      >
        {header}
      </CardHeader>
      <Collapse isOpen={isOpen}>
        <CardBody className={styles.cardBody}>
          {children != null ? children : empty}
        </CardBody>
      </Collapse>
    </Card>
  );
};

export { SitebarCollapsable };
